const CollectionPage = {
    init: function() {
      console.log('Iniciando CollectionPage');
      if (!document.body.classList.contains('template-collection')) {
        console.log('No estamos en la página de colección');
        return;
      }
  
      this.updateFreeShippingFilterVisibility();
      this.observeUrlChanges();
      this.observeFilterChanges();
      this.observeAjaxFilterChanges();
    },
  
    updateFreeShippingFilterVisibility: function() {
      const urlParams = new URLSearchParams(window.location.search);
      const hasPriceFilter = urlParams.has('filter.v.price.gte');
  
      console.log('¿Tiene filtro de precio?', hasPriceFilter);
  
      this.updateFilterVisibility('.thb-filter-price-free-shipping-desktop', hasPriceFilter, 'desktop');
      this.updateFilterVisibility('.thb-filter-price-free-shipping-mobile', hasPriceFilter, 'mobile');
    },
  
    updateFilterVisibility: function(selector, hide, type) {
      const filter = document.querySelector(selector);
      if (!filter) {
        console.log(`Filtro ${type} no encontrado`);
        return;
      }
  
      if (hide) {
        console.log(`Ocultando filtro de envío gratis (${type})`);
        filter.style.display = 'none';
        filter.setAttribute('data-hidden', 'true');
      } else {
        console.log(`Mostrando filtro de envío gratis (${type})`);
        filter.style.display = '';
        filter.removeAttribute('data-hidden');
      }
      console.log(`Estado del filtro (${type}) después de la actualización:`, filter.style.display);
    },
  
    observeUrlChanges: function() {
      console.log('Configurando observador de cambios de URL');
      let lastUrl = location.href; 
      new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
          console.log('URL cambiada. Actualizando visibilidad de los filtros.');
          lastUrl = url;
          this.updateFreeShippingFilterVisibility();
        }
      }).observe(document, {subtree: true, childList: true});
    },
  
    observeFilterChanges: function() {
      console.log('Configurando observador de cambios en los filtros');
      const filterContainer = document.querySelector('.thb-filter-container');
      if (filterContainer) {
        const observer = new MutationObserver((mutations) => {
          console.log('Cambio detectado en los filtros');
          this.updateFreeShippingFilterVisibility();
        });
        observer.observe(filterContainer, { childList: true, subtree: true });
      } else {
        console.log('No se encontró el contenedor de filtros');
      }
    },
  
    observeAjaxFilterChanges: function() {
      console.log('Configurando observador de cambios AJAX en los filtros');
      document.addEventListener('click', (event) => {
        const clickedFilter = event.target.closest('.thb-filter-price-free-shipping-desktop, .thb-filter-price-free-shipping-mobile');
        
        if (clickedFilter) {
          console.log('Clic detectado en filtro de envío gratis');
          this.handleFilterClick();
        }
      });
    },
  
    handleFilterClick: function() {
      const checkAndUpdateFilters = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const hasPriceFilter = urlParams.has('filter.v.price.gte');
        
        this.updateFreeShippingFilterVisibility();
  
        if (hasPriceFilter) {
          console.log('Filtro de precio aplicado, deteniendo comprobaciones');
          clearInterval(checkInterval);
        }
      };
  
      // Comprobar inmediatamente
      checkAndUpdateFilters();
  
      // Continuar comprobando cada 100ms durante 2 segundos
      const checkInterval = setInterval(checkAndUpdateFilters, 100);
      setTimeout(() => clearInterval(checkInterval), 2000);
    }
  };
  
  // Inicializar la página de colección cuando el DOM esté listo
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM cargado. Inicializando CollectionPage.');
    CollectionPage.init();
  });
  
  // Asegurarse de que se actualice la visibilidad después de que la página se haya cargado completamente
  window.addEventListener('load', function() {
    console.log('Página completamente cargada');
    if (document.body.classList.contains('template-collection')) {
      console.log('Actualizando visibilidad de los filtros después de la carga completa');
      CollectionPage.updateFreeShippingFilterVisibility();
    }
  });
  
  // Añadir un listener para el evento AJAX de Shopify
  document.addEventListener('shopify:section:load', function(event) {
    console.log('Evento shopify:section:load detectado');
    if (document.body.classList.contains('template-collection')) {
      console.log('Actualizando visibilidad de los filtros después de la carga de sección');
      CollectionPage.updateFreeShippingFilterVisibility();
    }
  });
  
  // Añadir un log para verificar que el script se está cargando
  console.log('Script de CollectionPage cargado');